/* Map program icon names to lucide-react components. */
import {
  Award, Cpu, MonitorCog, ShieldCheck, Code2, Brain, Palette, Vote,
  MessageCircle, Briefcase, Sparkles, BookOpen,
} from 'lucide-react';

const ICONS = {
  Award, Cpu, MonitorCog, ShieldCheck, Code2, Brain, Palette, Vote,
  MessageCircle, Briefcase, Sparkles,
};

export default function ProgramIcon({ name, className }) {
  const Cmp = ICONS[name] || BookOpen;
  return <Cmp className={className} strokeWidth={1.8} />;
}
